var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"-24px -24px 0"}},[_c('div',{staticClass:"page-header"},[_c('BreadCrumb'),_c('div',{staticClass:"page-header-detail"},[_vm._t("page-header-detail")],2)],1),_c('div',{staticClass:"page-content",attrs:{"id":"page-content"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }